export default __webpack_public_path__ + "static/media/mini-btn-plus.76cc6f56.svg";